import React, { useEffect, useState } from "react";
import { Card, Col, Container, Row } from "react-bootstrap";
import ProductsData from "../../home/Products/productsData";
import AppBreadcrumb from "../../../components/template/BreadCrumb/AppBreadcrumb";
// scss
import "./style.scss";
import MetaInformation from "../../../utils/meta/MetaInformation";

const descriptionListOfHomeScreen = [
  "The Home Screen's primary purpose is to display the analogue sensor, gas sensor, time, and date values. controls the anesthesia timer, operation timer, digital output buttons. The provided is marked as follows.",
  "The home screen will appear when the home button is clicked.",
  "The time and date will correspond to those of the current location.",
  "During the period of the operation and anesthesia, the Operation and Anesthetic Timer is used. The BUSY digital output button can also be used to manage operation time.",
  "Different sensors and lights are controlled by digital output buttons",
];

const descriptionOfHomeScreen =
  "The Home Screen's primary purpose is to display the analogue sensor, gas sensor, time, and date values. controls the anesthesia timer, operation timer, digital output buttons. The provided is marked as follows.";

const ControlPanel = () => {
  const [controlPanelMainData, setControlPanelMainData] = useState({});
  const [controlPanelImagesData, setControlPanelImagesData] = useState([]);
  const [activeImage, setActiveImage] = useState("");
  const [activeTab, setActiveTab] = useState("Beschreibung");
  const [activeTitle, setActiveTitle] = useState("Home Screen");
  const [activeDescription, setActiveDescription] = useState(
    descriptionOfHomeScreen
  );
  const [activeDescriptionList, setActiveDescriptionList] = useState(
    descriptionListOfHomeScreen
  );

  useEffect(() => {
    const controlPanelObj = ProductsData.find(
      (product) => product.title === "Control Panel"
    );
    setControlPanelMainData(controlPanelObj);

    const controlPanelImagesData = controlPanelObj.imagesData;
    setControlPanelImagesData(controlPanelImagesData);

    setActiveImage(controlPanelImagesData[0].image);
  }, []);

  const activeHandler = (event) => {
    setActiveTab(event.target.value);
  };

  const handleImageData = (imageData) => {
    setActiveImage(imageData.image);
    setActiveTitle(imageData.imageTitle);
    setActiveDescription(imageData.imageDescription);
    setActiveDescriptionList(imageData.imageDescriptionList);
  };

  return (
    <>
      <MetaInformation
        title="Control Panel - HERZMANN"
        name="Product details route"
        content="Showing details of control panel"
      />
      <AppBreadcrumb></AppBreadcrumb>
      <main className="control_panel_main">
        <Container fluid="lg">
          <Row>
            <Col className="p-3">
              <article>
                <div className="d-flex justify-content-center flex-row gap-3 flex-md-column align-items-center">
                  <Card className="d-flex justify-content-center align-items-center img-container">
                    <img src={activeImage} alt="instrument" />
                  </Card>
                  <span className="d-flex justify-content-center align-items-center flex-wrap gap-1">
                    {controlPanelImagesData?.map((imageData, index) => {
                      return (
                        <Card
                          className={
                            imageData.image === activeImage
                              ? "ActiveImage d-flex justify-content-center align-items-center"
                              : "d-flex justify-content-center align-items-center"
                          }
                          key={index}
                          onClick={() => handleImageData(imageData)}
                        >
                          <img
                            src={imageData.image}
                            alt="instrument"
                            className="cursor-pointer"
                          />
                        </Card>
                      );
                    })}
                  </span>
                </div>
                <div>
                  <h4>{activeTitle}</h4>
                  <p>{activeDescription}</p>
                  <ul className="mt-3">
                    {activeDescriptionList?.map((state, index) => (
                      <li key={index}>{state}</li>
                    ))}
                  </ul>
                </div>
              </article>
            </Col>
          </Row>
          <Row className="mt-4">
            <Col className="p-3">
              <span>
                <button
                  value="Beschreibung"
                  className={activeTab === "Beschreibung" ? "Active" : ""}
                  onClick={activeHandler}
                >
                  Beschreibung
                </button>
                <button
                  value="Technische Information"
                  className={
                    activeTab === "Technische Information" ? "Active" : ""
                  }
                  onClick={activeHandler}
                >
                  Technische Information
                </button>
              </span>

              {activeTab === "Beschreibung" && (
                <ul className="mt-3">
                  {controlPanelMainData.description?.map((state, index) => (
                    <li key={index}>{state}</li>
                  ))}
                </ul>
              )}

              {activeTab === "Technische Information" && (
                <ul className="mt-3">
                  {controlPanelMainData.technicalInfo?.map((state, index) => (
                    <li key={index}>{state}</li>
                  ))}
                </ul>
              )}
            </Col>
          </Row>
        </Container>
      </main>
    </>
  );
};

export default ControlPanel;
